// src/scripts/main.js
$(document).ready(function() {
    const channels = [
        {
            name: 'ACI Sport',
            img: 'https://foto2.newsauto.it/wp-content/uploads/2021/03/ACI_Sport_TV-780x470.jpg',
            stream: 'https://webstream.multistream.it/memfs/e2cb3629-c1a2-495b-b43a-9eb386f04ed8.m3u8'
        },
        {
            name: 'Adrenalina Tv',
            img: '',
            stream: 'https://iptv.vivatele.com:443/live/viva_padrao/viva2384/64.m3u8'
        },
        {
            name: 'AMC',
            img: '',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://78.108.251.7/amc/index.m3u8'
        },
        {
            name: 'Anime Tv',
            img: 'animetv.png',
            stream: 'https://stmv1.srvif.com/anime/anime/playlist.m3u8'
        },
        {
            name: 'ATV Movies',
            img: '',
            stream: 'https://30a-tv.com/feeds/pzaz/30atvmovies.m3u8'
        },
        {
            name: 'AXN',
            img: 'logo-axn.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/https://streamer1.nexgen.bz/AXN/index.m3u8'
        },
        {
            name: 'Azteca',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSU_TrmYXcXhJIskR86V9cMj_rnkarFo70lLw&s',
            stream: 'https://azt-mun.otteravision.com/azt/mun/mun.m3u8'
        },
        {
            name: 'Azzurra TV',
            img: 'azzurra.png',
            stream: 'https://ed05.top-ix.org/avtvlive/azzurra/streaming/playlist.m3u8'
        },
        {
            name: "Bar\xe7a One",
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-E5D7AiLynjbpxELckPJczRJbBaYrQax-gA&s',
            stream: 'https://amg17560-fcb-amg17560c2-rakuten-es-4889.playouts.now.amagi.tv/playlist_fc18f0fd_2d126755.m3u8'
        },
        {
            name: 'Band',
            img: 'logo-band.png',
            stream: 'https://gerenciar.vivatele.com:443/viva_padrao/viva2384/3.m3u8'
        },
        {
            name: 'Band News',
            img: 'logo-bandnews.png',
            stream: 'https://cdn-3.nxplay.com.br/BAND_NEWS/tracks-v2a1/mono.m3u8'
        },
        {
            name: 'Band Sports',
            img: 'logo-bandsports.png',
            stream: 'https://cdn-2.nxplay.com.br/BAND_SPORTS/tracks-v2a1/mono.m3u8'
        },
        {
            name: 'BBC News',
            img: 'https://veja.abril.com.br/wp-content/uploads/2016/11/bbc14.jpg?quality=70&strip=all&w=720&crop=1',
            stream: 'https://vs-hls-push-ww-live.akamaized.net/x=4/i=urn:bbc:pips:service:bbc_news_channel_hd/t=3840/v=pv14/b=5070016/main.m3u8'
        },
        {
            name: 'BBC TopGear',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUzYhyND_Gd43sRxOooG_E82ZmFvWZo4JgsA&s',
            stream: 'https://amg00793-bbcstudios-amg00793c4-lg-us-2527.playouts.now.amagi.tv/playlist/amg00793-bbcstudios-bbctopgear8min-lgus/playlist.m3u8'
        },
        {
            name: 'Bein Sports',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT920R5QuL30gb5JvijDr9nIH2HbWh5od2UvQ&s',
            stream: 'https://corestream.ronaldovurdu.help//hls/bein-sports-1.m3u8'
        },
        {
            name: 'Bein Sports X',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT920R5QuL30gb5JvijDr9nIH2HbWh5od2UvQ&s',
            stream: 'https://bein-esp-klowdtv.amagi.tv/playlist.m3u8'
        },
        {
            name: 'BEK Sports',
            img: 'https://cdn.bek.coop/social-images/BEK-Sports-Social.jpg',
            stream: 'https://cdn3.wowza.com/5/ZWQ1K2NYTmpFbGsr/BEK-WOWZA-1/smil:BEKPRIMEW.smil/playlist.m3u8'
        },
        {
            name: 'Blues TV',
            img: 'bluestv.png',
            stream: 'https://2-fss-2.streamhoster.com/pl_138/205510-3094608-1/playlist.m3u8'
        },
        {
            name: 'Bob Esponja',
            img: '',
            stream: 'https://iptv.vivatele.com:443/live/viva_padrao/viva2384/86.m3u8'
        },
        {
            name: 'Bora Filmes',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDzB7ZHSZwnDRGiDldxtfmTsvWScz5mtXRFA&s',
            stream: 'https://cdn-3.nxplay.com.br/BORAFILMES_FAST/tracks-v1a1/mono.ts.m3u8?&zoneid=24425'
        },
        {
            name: 'C+ Sports1',
            img: 'https://od.lk/s/M18yOTczMTIwOTVf/canal%2BFoot.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://99.27.51.147:8080/Infosport/index.m3u8'
        },
        {
            name: 'Canale 88',
            img: 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/99/6b/c6/996bc6c3-9495-0e3d-98ab-7c5f1a67c6a7/AppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/1200x630wa.png',
            stream: 'https://srvx1.selftv.video/dmchannel/live/playlist.m3u8'
        },
        {
            name: 'Canela Deportes',
            img: 'https://yt3.googleusercontent.com/tJAN8AAu78kkFfG12IhPOBgz3Dh_FolNRq4rg-_hdjnz8STCRI1srjL7eamBzepD9n5l5cNg9Q=s900-c-k-c0x00ffffff-no-rj',
            stream: 'https://cdn-uw2-prod.tsv2.amagi.tv/linear/amg00658-canelamediainc-caneladeportes-rewardedtv/playlist.m3u8'
        },
        {
            name: "Cine Com\xe9dia",
            img: 'https://images.pluto.tv/channels/5dcdde78f080d900098550e4/featuredImage_1760982311641.jpg',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://stitcher-ipv4.pluto.tv/v1/stitch/embed/hls/channel/5f12101f0b12f00007844c7c/master.m3u8?deviceType=samsung-tvplus&deviceMake=samsung&deviceModel=samsung&deviceVersion=unknown&appVersion=unknown&deviceLat=0&deviceLon=0&deviceDNT=%7BTARGETOPT%7D&deviceId=%7BPSID%7D&advertisingId=%7BPSID%7D&us_privacy=1YNY&samsung_app_domain=%7BAPP_DOMAIN%7D&samsung_app_name=%7BAPP_NAME%7D&profileLimit=&profileFloor=&embedPartner=samsung-tvplus'
        },
        {
            name: 'Cine Drama',
            img: 'https://images.pluto.tv/channels/5f1210d14ae1f80007bafb1d/featuredImage.jpg',
            stream: 'https://cors-anywhere-d1oq.onrender.com/https://stitcher-ipv4.pluto.tv/v1/stitch/embed/hls/channel/5f1210d14ae1f80007bafb1d/master.m3u8?deviceType=samsung-tvplus&deviceMake=samsung&deviceModel=samsung&deviceVersion=unknown&appVersion=unknown&deviceLat=0&deviceLon=0&deviceDNT=%7BTARGETOPT%7D&deviceId=%7BPSID%7D&advertisingId=%7BPSID%7D&us_privacy=1YNY&samsung_app_domain=%7BAPP_DOMAIN%7D&samsung_app_name=%7BAPP_NAME%7D&profileLimit=&profileFloor=&embedPartner=samsung-tvplus&'
        },
        {
            name: 'Cindie Lite',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8Vg_Z8Sm9dGn-Z9Cczfi429F-XmTzoBbyNg&s',
            stream: 'https://cc-hqw8u5r1nshjc.akamaized.net/scheduler/scheduleMaster/352.m3u8'
        },
        {
            name: 'Cine Sucesso',
            img: 'https://images.pluto.tv/channels/5f120e94a5714d00074576a1/featuredImage.jpg?auto=&q=70&fit=fill&fill=blur&ixlib=react-9.1.5',
            stream: 'https://cors-anywhere-d1oq.onrender.com/https://stitcher-ipv4.pluto.tv/v1/stitch/embed/hls/channel/5f120e94a5714d00074576a1/master.m3u8?deviceType=samsung-tvplus&deviceMake=samsung&deviceModel=samsung&deviceVersion=unknown&appVersion=unknown&deviceLat=0&deviceLon=0&deviceDNT=%7BTARGETOPT%7D&deviceId=%7BPSID%7D&advertisingId=%7BPSID%7D&us_privacy=1YNY&samsung_app_domain=%7BAPP_DOMAIN%7D&samsung_app_name=%7BAPP_NAME%7D&profileLimit=&profileFloor=&embedPartner=samsung-tvplus&'
        },
        {
            name: 'CNN Brasil',
            img: 'https://i0.wp.com/assets.b9.com.br/wp-content/uploads/2019/03/cnn-brasil.jpg?fit=1280%2C720&ssl=1',
            stream: 'https://d25usgadhphvwi.cloudfront.net/hls/main.m3u8'
        },
        {
            name: 'CNN PT',
            img: 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/5e/0e/43/5e0e4360-6396-64d3-6d64-0e495c2b7840/AppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/1200x630wa.png',
            stream: 'https://raw.githubusercontent.com/ipstreet312/freeiptv/master/ressources/tvipt/sh/cnnpt.m3u8'
        },
        {
            name: 'CNN USA',
            img: 'logo-cnn.png',
            stream: 'https://turnerlive.warnermediacdn.com/hls/live/586495/cnngo/cnn_slate/VIDEO_0_3564000.m3u8'
        },
        {
            name: 'CombaTV',
            img: 'combatv.png',
            stream: 'https://aym-cbtv.otteravision.com/aym/cbtv/cbtv.m3u8'
        },
        {
            name: 'ConectTV',
            img: 'https://yt3.googleusercontent.com/9Zrl6psqQDobaLMkdfGFcSl2gqNNtcQhcoYW7mPFeK6YwIExqePsck1LT3AUu1JiX5jcgaEP=s900-c-k-c0x00ffffff-no-rj',
            stream: 'https://stream01.msolutionbrasil.com.br/hls/conectv/live.m3u8'
        },
        {
            name: 'Cult Classic',
            img: 'cultmovie.png',
            stream: 'https://app.viloud.tv/hls/channel/053140e08adc29e3eac61eb05ff12f51.m3u8'
        },
        {
            name: 'Darkflix',
            img: 'https://t.ctcdn.com.br/OTDMs9zWXK__11eQ8Q5qEg3cAmo=/1200x675/smart/i483359.jpeg',
            stream: 'https://video01.soultv.com.br/darkflix/darkflix/playlist.m3u8'
        },
        {
            name: 'DAZN Combate',
            img: '',
            stream: 'https://dazn-combat-rakuten.amagi.tv/hls/amagi_hls_data_rakutenAA-dazn-combat-rakuten/CDN/master.m3u8'
        },
        {
            name: 'Discovery',
            img: 'logo-discovery.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://hls1.sua.tv:80/live/discoverychannelfhd/s.m3u8'
        },
        {
            name: 'Discovery kids',
            img: 'logo-discoverykids.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://104.238.205.28:8989/278536_.m3u8'
        },
        {
            name: 'Dreamworks',
            img: 'dreamworks.png',
            stream: 'https://cdn-3.nxplay.com.br/DREAMWORKS/tracks-v2a1/mono.m3u8'
        },
        {
            name: 'El Trece',
            img: 'https://television.com.ar/wp-content/uploads/2024/01/eltrece-logo-tapa-1.jpg',
            stream: 'https://live-01-02-eltrece.vodgc.net/eltrecetv/index.m3u8'
        },
        {
            name: 'ESPN USA',
            img: 'espn4.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://41.205.93.154/ESPN/index.m3u8'
        },
        {
            name: 'ESPN',
            img: 'logo-espn.png',
            stream: 'https://cdn01.oplay.tv/espn/index.m3u8'
        },
        {
            name: 'ESPN 2',
            img: 'logo-espn2.png',
            stream: 'https://cdn01.oplay.tv/espn/index.m3u8'
        },
        {
            name: 'ESPN 3',
            img: 'logo-espn3.png',
            stream: 'https://cdn-2.nxplay.com.br/ESPN_3/index.m3u8'
        },
        {
            name: 'ESPN Deportes',
            img: 'logo-espn3.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://23.237.104.106:8080/USA_FOX_DEPORTES/index.m3u8'
        },
        {
            name: 'ESPN 3',
            img: 'logo-espn3.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://104.238.205.28:8989/278558_.m3u8'
        },
        {
            name: 'ESPN 4',
            img: 'espn4.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://104.238.205.28:8989/278566_.m3u8'
        },
        {
            name: 'ESPN 6',
            img: 'espn4.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://hls1.sua.tv:80/live/espnextrafhd/s.m3u8'
        },
        {
            name: 'Eurosport 1',
            img: 'https://logovectorseek.com/wp-content/uploads/2019/09/eurosport-1-logo-vector-xs.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://185.189.225.157/EuroSport1/index.m3u8'
        },
        {
            name: 'Eurosport 2',
            img: 'https://logovectorseek.com/wp-content/uploads/2019/09/eurosport-2-logo-vector-xs.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://185.189.225.157/EuroSport2/index.m3u8'
        },
        {
            name: 'FIFA Plus',
            img: 'logo-fifa.png',
            stream: 'https://e834459f.wurl.com/master/f36d25e7e52f1ba8d7e56eb859c636563214f541/U2Ftc3VuZy1icl9GSUZBUGx1c1BvcnR1Z3Vlc2VfSExT/playlist.m3u8'
        },
        {
            name: 'Fox News Now',
            img: 'logo-foxnow.png',
            stream: 'https://d3tlzddkbbpp5n.cloudfront.net/v1/master/3722c60a815c199d9c0ef36c5b73da68a62b09d1/cc-9uzjfw11uj9nn/LiveNOW_from_FOX.m3u8'
        },
        {
            name: 'Globo',
            img: 'logo-globo.png',
            stream: 'https://iptv.vivatele.com/live/viva_padrao/viva2384/1.m3u8'
        },
        {
            name: 'Globo',
            img: 'logo-globo.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://hls1.sua.tv/live/globotvbahiafhdbr2/s.m3u8'
        },
        {
            name: 'GETV',
            img: 'logo-globo.png',
            stream: 'https://amg00716-globo-amg00716c1-tcl-br-9495.playouts.now.amagi.tv/720p-cc/index.m3u8'
        },
        {
            name: 'HBO USA',
            img: '',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://23.237.104.106:8080/USA_HBO/index.m3u8'
        },
        {
            name: 'HBO ',
            img: '',
            stream: 'https://cdn01.oplay.tv/hbo/index.m3u8'
        },
        {
            name: 'HBO Comedy',
            img: '',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://23.237.104.106:8080/USA_HBO_COMEDY/index.m3u8'
        },
        {
            name: 'Hallo Anime',
            img: 'halloanime.png',
            stream: 'https://cdn-3.nxplay.com.br/HALLOANIME/index.m3u8'
        },
        {
            name: 'Hallo Doc',
            img: 'https://hallo.tv.br/img/DOC.png',
            stream: 'https://cdn-3.nxplay.com.br/HALLODOC/index.m3u8'
        },
        {
            name: 'Hallo Classic',
            img: 'https://hallo.tv.br/img/CLASSIC.png',
            stream: 'https://cdn-3.nxplay.com.br/HALLOCLASSIC/index.m3u8'
        },
        {
            name: 'Hallo Movies',
            img: 'hallomovie.png',
            stream: 'https://cdn-3.nxplay.com.br/HALLOMOVIES/index.m3u8'
        },
        {
            name: 'Hallo Series',
            img: 'https://hallo.tv.br/img/SERIES.png',
            stream: 'https://cdn-3.nxplay.com.br/HALLOSERIES/index.m3u8'
        },
        {
            name: 'History',
            img: 'logo-history.png',
            stream: 'https://cdn-2.nxplay.com.br/HISTORY_TK/tracks-v1a1/mono.m3u8'
        },
        {
            name: 'History Esp',
            img: 'logo-history.png',
            stream: 'https://stream1.freetv.fun/09f15ea38f4d1af6b7e1324f6b92d63b631b2498d9ee8c7a3017afd8ab8c63cb.m3u8'
        },
        {
            name: 'History Ru',
            img: 'logo-history.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/https://vod.splay.uz/live_splay/original/History/tracks-v1a1/mono.m3u8'
        },
        {
            name: 'History 2',
            img: 'https://th.bing.com/th/id/OIP.vu_R75k_pHEk3oQX04M6XwAAAA?w=384&h=216&rs=1&pid=ImgDetMain',
            stream: 'https://cdn-2.nxplay.com.br/HISTORY_2_TK/index.m3u8'
        },
        {
            name: 'KBS',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4moM5Pyi8Job61y5qyLHMl19QnGg0MgL42A&s',
            stream: 'https://wms4-kortv.akamaized.net/a_live/63719963/smil:20ch011.smil/playlist.m3u8'
        },
        {
            name: 'Kiss TV',
            img: 'logo-kiss.png',
            stream: 'https://isaocorp.cloudecast.com/kisstv/index.m3u8'
        },
        {
            name: 'La 3',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkOjTSCePUp7HVhh11M93yzbBZ76RUN7s5aQ&s',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://69.64.57.208/la3/playlist.m3u8'
        },
        {
            name: 'Lazio TV',
            img: 'lazio.png',
            stream: 'https://streaming.softwarecreation.it/LazioTv/LazioTv/playlist.m3u8'
        },
        {
            name: 'LEquipe 1',
            img: 'https://medias.lequipe.fr/img-photo-png/-/1500000000833469/0-0-0-70/0cb67.png',
            stream: 'https://d3awaj0f2u3w26.cloudfront.net/v1/master/3722c60a815c199d9c0ef36c5b73da68a62b09d1/cc-gy7euubgydp20-ssai-prd/master.m3u8'
        },
        {
            name: 'LEquipe 2',
            img: 'https://medias.lequipe.fr/img-photo-png/-/1500000000833469/0-0-0-70/0cb67.png',
            stream: 'https://d2l55nvfkhk4sg.cloudfront.net/v1/master/3722c60a815c199d9c0ef36c5b73da68a62b09d1/cc-jg7go1lqzgpny-ssai-prd/master.m3u8'
        },
        {
            name: 'Loading TV',
            img: 'https://th.bing.com/th/id/OIP.xqvFy7LR2KpPFjKeYbejogHaFj?rs=1&pid=ImgDetMain',
            stream: 'https://stmv1.srvif.com/loadingtv/loadingtv/playlist.m3u8'
        },
        {
            name: 'Lone Star',
            img: 'logo-lonestar.png',
            stream: 'https://lonestar-rakuten.amagi.tv/playlist.m3u8'
        },
        {
            name: 'Love Nature',
            img: '',
            stream: 'https://iptv.vivatele.com:443/live/viva_padrao/viva2384/114.m3u8'
        },
        {
            name: 'Nat Geo',
            img: '',
            stream: 'https://cdn01.oplay.tv/natgeo/index.m3u8'
        },
        {
            name: 'Netmovies',
            img: 'https://cdn.telaviva.com.br/wp-content/uploads/2020/10/net-movies.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/https://stitcher-ipv4.pluto.tv/v1/stitch/embed/hls/channel/663b9de4f999220008230fa8/master.m3u8?deviceType=samsung-tvplus&deviceMake=samsung&deviceModel=samsung&deviceVersion=unknown&appVersion=unknown&deviceLat=0&deviceLon=0&deviceDNT=%7BTARGETOPT%7D&deviceId=%7BPSID%7D&advertisingId=%7BPSID%7D&us_privacy=1YNY&samsung_app_domain=%7BAPP_DOMAIN%7D&samsung_app_name=%7BAPP_NAME%7D&profileLimit=&profileFloor=&embedPartner=samsung-tvplus&'
        },
        {
            name: 'NHK',
            img: 'https://advanced-television.com/wp-content/uploads/2023/10/NHKpremium.jpg',
            stream: 'https://media-tyo.hls.nhkworld.jp/hls/w/live/master.m3u8'
        },
        {
            name: 'NSports',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTa5VcNeq6EFUfIMIN79_2ftwkc9ttYOhcMxA&s',
            stream: 'https://video01.soultv.com.br/nsports/nsports/playlist.m3u8'
        },
        {
            name: 'MotorVision',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ3dYVQO2jIb3lqlm7aCKegiR3YvstbPkbkhA&s',
            stream: 'https://mvg-mv-pt.otteravision.com/mvg/mv_pt/mv_pt.m3u8'
        },
        {
            name: 'Miramax',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1nhqu_XZ5AO6X5KNZOrw6_8rSqlWwD8jf6w&s',
            stream: 'https://linear-798.frequency.stream/mt/plex/798/hls/master/playlist.m3u8'
        },
        {
            name: 'MovieSphere',
            img: 'https://10play.com.au/ip/s3/2023/01/25/f0a87010a3de3fbfb828dbdbc7fdabb6-1213478.jpg?io=landscape',
            stream: 'https://cdn-uw2-prod.tsv2.amagi.tv/linear/amg00353-lionsgatestudio-moviespherebrazil-samsungbr/playlist.m3u8?ManoTV'
        },
        {
            name: 'MultiVision',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgbDac7gWaxOS4pxMJ1dEA_Ble21I1JcRGEg&s',
            stream: 'https://stream.digitalgt.com:3605/live/multivisionsportslive.m3u8'
        },
        {
            name: 'My Time',
            img: 'logo-mytime.png',
            stream: 'https://iptv.vivatele.com:443/live/viva_padrao/viva2384/54.m3u8'
        },
        {
            name: 'Otaku Sign TV',
            img: 'otaku.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://200.194.238.229:8383/live/otaku/playlist.m3u8'
        },
        {
            name: 'Outdoor Sports',
            img: 'https://bassanglermag.com/wp-content/uploads/Outdoor-Channel.png',
            stream: 'https://gto2000-sportoutdoortv-1-it.samsung.wurl.tv/playlist.m3u8'
        },
        {
            name: 'Paramount',
            img: 'paramount.png',
            stream: 'https://cdn01.oplay.tv/paramount/index.m3u8'
        },
        {
            name: 'Premiere',
            img: 'logo-premiere.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://104.238.222.251:8989/278939_.m3u8'
        },
        {
            name: 'Premiere 2',
            img: 'logo-premiere2.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://104.238.222.251:8989/278937_.m3u8'
        },
        {
            name: 'Premiere 3',
            img: 'logo-premiere3.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://104.238.222.251:8989/278940_.m3u88'
        },
        {
            name: 'Rai1',
            img: 'https://italianismo.com.br/wp-content/uploads/2025/09/rai-1.png',
            stream: 'https://dash2.antik.sk/live/test_rai_uno_tizen/playlist.m3u8'
        },
        {
            name: 'Real Madrid TV',
            img: 'realmadrid.png',
            stream: 'https://rmtv.akamaized.net/hls/live/2043153/rmtv-es-web/master.m3u8'
        },
        {
            name: 'Record',
            img: 'logo-record.png',
            stream: 'https://gerenciar.vivatele.com:443/viva_padrao/viva2384/13.m3u8'
        },
        {
            name: 'Red Bull TV',
            img: 'redbulltv.png',
            stream: 'https://rbmn-live.akamaized.net/hls/live/590964/BoRB-AT/master_6660.m3u8'
        },
        {
            name: 'Rock TV',
            img: 'https://th.bing.com/th/id/OIP.r-LwvXaqe_bklWb6ylddVgAAAA?rs=1&pid=ImgDetMain',
            stream: 'https://tv.broadcasting.ro/rocktv/85c83a80-4f71-4f2d-a8d6-43f676896bcb.m3u8'
        },
        {
            name: 'Run Time',
            img: 'https://image.roku.com/developer_channels/prod/54813a041607e478cee2b64e2859ce83ff355280a62bcbe94da6babc656ce3dd.png',
            stream: 'https://stream.ads.ottera.tv/playlist.m3u8?network_id=2153'
        },
        {
            name: "Run Time A\xe7\xe3o",
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToZk20_mPIdVGXU1tc09MK4K8gUiUkT7LGCA&s',
            stream: 'https://stream.ads.ottera.tv/playlist.m3u8?network_id=2552'
        },
        {
            name: 'Run Time Crime',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToZk20_mPIdVGXU1tc09MK4K8gUiUkT7LGCA&s',
            stream: 'https://stream.ads.ottera.tv/playlist.m3u8?network_id=4864'
        },
        {
            name: "Run Time Com\xe9dia",
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToZk20_mPIdVGXU1tc09MK4K8gUiUkT7LGCA&s',
            stream: 'https://stream.ads.ottera.tv/playlist.m3u8?network_id=2553'
        },
        {
            name: 'SBT',
            img: 'logo-sbt.png',
            stream: 'https://iptv.vivatele.com:443/live/viva_padrao/viva2384/2.m3u8'
        },
        {
            name: 'SBT',
            img: 'logo-sbt.png',
            stream: 'https://stream.amsolution.net.br:8443/live/66db1cf131d45/index.m3u8'
        },
        {
            name: 'Sesc TV',
            img: '',
            stream: 'https://iptv.vivatele.com:443/live/viva_padrao/viva2384/48.m3u8'
        },
        {
            name: "SIC Not\xedcias",
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvgtd7THT6-SzCcFCJVL9dYMaceyko0RdUpw&s',
            stream: 'https://d277k9d1h9dro4.cloudfront.net/out/v1/293e7c3464824cbd8818ab8e49dc5fe9/index.m3u8'
        },
        {
            name: 'SIC PT',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR3-e0M12BQxP0sUX68h5WRmnlH5UQGpeVLXw&s',
            stream: 'https://d1zx6l1dn8vaj5.cloudfront.net/out/v1/b89cc37caa6d418eb423cf092a2ef970/index_4.m3u8'
        },
        {
            name: 'Sky Open',
            img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Sky_Open_Logo.png/1200px-Sky_Open_Logo.png',
            stream: 'https://linear-p.media.skyone.co.nz/primeplus1.clear.m3u8'
        },
        {
            name: 'Sky 1',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyCw7TWCTN8EB-ORDcU3uEO1kc66QJM7fXdA&s',
            stream: 'https://d85lu9l3axp7b.cloudfront.net/v1/master/3722c60a815c199d9c0ef36c5b73da68a62b09d1/cc-49b4g6287mnav/playlist.m3u8'
        },
        {
            name: 'Smithsonian',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmX5JzdgiYDQe3Rvh4inkmlJv3VVwDrAI2Fg&s',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://stitcher-ipv4.pluto.tv/v1/stitch/embed/hls/channel/6298bd10d88ef000073f16b7/master.m3u8?deviceType=samsung-tvplus&deviceMake=samsung&deviceModel=samsung&deviceVersion=unknown&appVersion=unknown&deviceLat=0&deviceLon=0&deviceDNT=%7BTARGETOPT%7D&deviceId=%7BPSID%7D&advertisingId=%7BPSID%7D&us_privacy=1YNY&samsung_app_domain=%7BAPP_DOMAIN%7D&samsung_app_name=%7BAPP_NAME%7D&profileLimit=&profileFloor=&embedPartner=samsung-tvplus'
        },
        {
            name: 'Sony Channel',
            img: 'https://play-lh.googleusercontent.com/fv2t4tFKJANqwXsaaG5EsjbOMS5zeX360nGmDASnuvqi6c-BdoNzTJMsNPS3TEJP6pE=w600-h300-pc0xffffff-pd',
            stream: 'https://f9387554367349db8374885adb2d48cf.mediatailor.us-east-1.amazonaws.com/v1/master/0fb304b2320b25f067414d481a779b77db81760d/Samsung-br_SonyOneEmocoes/playlist.m3u8?ManoTV'
        },
        {
            name: 'Sony Movies',
            img: 'https://images-cdn3.welcomesoftware.com/assets/sony+movies+logo.png/Zz1jNzhlZTI2NGNlNzcxMWVkYmMwNmVlMDZjYWM2NDI3Ng==?width=1170&height=655',
            stream: 'https://spt-sonyoneclassicas-1-br.samsung.wurl.tv/playlist.m3u8'
        },
        {
            name: 'Space',
            img: 'logo-space.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://104.238.205.28:8989/278529_.m3u8'
        },
        {
            name: 'Spark TV',
            img: 'https://play-lh.googleusercontent.com/suAaZuVUeWsig-1PffJG6CP5PC639L74umMf7U6565AzyO5cCXe8s3P78S43bDkTfA',
            stream: 'https://candlelightmedia-sparklightlove-3-br.plex.wurl.tv/playlist.m3u8'
        },
        {
            name: 'Sport Italia',
            img: 'https://upload.wikimedia.org/wikipedia/it/archive/c/c0/20140513083418%21Sportitalia_Logo.JPG',
            stream: 'https://amg01370-italiansportcom-sportitalia-rakuten-3hmdb.amagi.tv/hls/amagi_hls_data_rakutenAA-sportitalia-rakuten/CDN/1920x1080_4540800/chunklist.m3u8'
        },
        {
            name: 'SI Solo Calcio',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhI50nuK8P2xPU9GqpmsL7QhNeqMVK0hamHA&s',
            stream: 'https://distribution.streamup.eu/sportitalia/sisolocalcio_abr/playlist.m3u8'
        },
        {
            name: 'Sports Connect',
            img: 'sportsconnect.png',
            stream: 'https://origin3.afxp.telemedia.co.za/PremiumFree/sportsconnect/playlist.m3u8'
        },
        {
            name: 'Sports TV',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPhqfMx8KqHMux8FHHw-PjUh3TQp1nfqAz_g&s',
            stream: 'https://live.sportstv.com.tr/hls/low/sportstv_fhd/index.m3u8'
        },
        {
            name: 'SporTV',
            img: 'logo-sportv.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://104.238.222.251:8989/278939_.m3u8'
        },
        {
            name: 'SporTV 2',
            img: 'logo-sportv2.png',
            stream: 'https://abc.embedmax.site/sportv2/index.m3u8'
        },
        {
            name: 'Star Channel',
            img: '',
            stream: 'https://cdn01.oplay.tv/star_channel/index.m3u8'
        },
        {
            name: 'SporTV 3',
            img: 'sportv3.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://104.238.222.251:8989/278944_.m3u8'
        },
        {
            name: 'Surf Now',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPIFlChMCpnH-IJvdNqPFwP0q0-djUUVJ8fg&s',
            stream: 'https://dgwfm675921lp.cloudfront.net/playlist.m3u8'
        },
        {
            name: 'TCM',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7bCMmR-N7bZQOyNanH2ZdK39t90adEp9CLg&s',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://212.102.60.10/TCM/index.m3u8'
        },
        {
            name: 'Televisa',
            img: '',
            stream: 'https://televisa-televisa-1-it.samsung.wurl.tv/playlist.m3u8?ManoTV'
        },
        {
            name: 'Tennis Ch',
            img: 'tennis.png',
            stream: 'https://amg01470-amg01470c1-samsung-br-4768.playouts.now.amagi.tv/playlist.m3u8'
        },
        {
            name: 'Tigo Sports',
            img: 'https://play-lh.googleusercontent.com/5TIm_0d23lkIy8_gLfJPVX2-660jpcEX-NejgJiNldwZn0tI7w8W8EQG8ClopvvM9A=w416-h235-rw',
            stream: 'https://live20.bozztv.com/akamaissh101/ssh101/livetigocr/playlist.m3u8'
        },
        {
            name: 'TLC',
            img: 'https://static.wikia.nocookie.net/tvpediabrasil/images/f/f6/Tlc.jpg/revision/latest?cb=20160719205248&path-prefix=pt-br',
            stream: 'https://cdn-2.nxplay.com.br/TLC_BR_NX/index.m3u8'
        },
        {
            name: 'TNT',
            img: 'logo-tnt.png',
            stream: 'https://cdn01.oplay.tv/tnt/index.m3u8'
        },
        {
            name: 'TNT',
            img: 'logo-tnt.png',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://cors.tundracast.com:2000/https://streamer1.nexgen.bz/TNT/index.m3u8'
        },
        {
            name: 'TNT Series',
            img: 'tntseries.png',
            stream: 'https://cdn-2.nxplay.com.br/TNT_SERIES_TK/index.m3u8'
        },
        {
            name: 'TVG',
            img: '',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://104.238.205.28:8989/278565_.m3u8'
        },
        {
            name: 'TUDN',
            img: '',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://104.238.205.28:8989/278570_.m3u8'
        },
        {
            name: 'TV One',
            img: 'https://play-lh.googleusercontent.com/qv34haXPHkAJGQn7prz_nBMjUmAd3-21ffWNIKZIPg_z-4G-0B2LxPIOB1BnK3zWzA',
            stream: 'https://video02.logicahost.com.br/tvone/tvone/playlist.m3u8'
        },
        {
            name: 'TVRI',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnQG69gEOJN39bd0vswBQPjlkXxH2voWvrIg&s',
            stream: 'https://ott-balancer.tvri.go.id/live/eds/SportHD/hls/SportHD.m3u8'
        },
        {
            name: 'TV Bulgaria',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWZVjkoaPWfQuLgf5o1q6BRDdkq8VQ0m-mxQ&s',
            stream: 'https://streamer103.neterra.tv/thisisbulgaria/live.m3u8'
        },
        {
            name: 'TVI PT',
            img: 'https://www.logotipo.pt/wp-content/uploads/2017/02/tvi.jpg',
            stream: 'https://video-auth2.iol.pt/live_vmais/live_vmais/edge_servers/vmais-720p/playlist.m3u8'
        },
        {
            name: 'Urban Docs',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQuL37UbbtJFcCthHo_joPfAkFykQ5sVlA_zw&s',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://200.194.238.229:8383/live/urbandocs/playlist.m3u8'
        },
        {
            name: 'Urban Movies',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQuL37UbbtJFcCthHo_joPfAkFykQ5sVlA_zw&s',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://200.194.238.229:8383/live/urbanmovies/playlist.m3u8'
        },
        {
            name: 'Urban Series',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQuL37UbbtJFcCthHo_joPfAkFykQ5sVlA_zw&s',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://200.194.238.229:8383/live/urbanseries/playlist.m3u8'
        },
        {
            name: 'Vclassic TV',
            img: 'https://htforum.net/data/attachments/18/18581-1dfe04edaf5c1617f899a0ebe814d068.jpg',
            stream: 'https://5eaccbab48461.streamlock.net:1936/8112/8112/playlist.m3u8'
        },
        {
            name: 'VH1',
            img: '',
            stream: 'https://cors-anywhere-d1oq.onrender.com/http://23.237.104.106:8080/USA_VH1/index.m3u8'
        },
        {
            name: 'Vintage TV',
            img: 'https://upload.wikimedia.org/wikipedia/en/6/67/Vintage_TV_channel_logo.png',
            stream: 'https://video01.kshost.com.br:4443/rogerio7271/rogerio7271/chunklist_w609200235.m3u8'
        },
        {
            name: 'Warner',
            img: 'warner.png',
            stream: 'https://cdn01.oplay.tv/warner/index.m3u8'
        },
        {
            name: 'Yahoo Sports',
            img: 'https://yt3.googleusercontent.com/8gEXUsVuj6vUS0F2x2kCY0SvSTg0otwCPGwZl6ztN8vJOtcGfwIs48Oo-82CHbIyRzzzBQyFfw=s900-c-k-c0x00ffffff-no-rj',
            stream: 'https://yahoo.global.transmit.live/hls/6862d5fd233e6604b8b457c6/09f289527d9545b38b36cfe7623c619f/us-east-1/6415665815001/playlist_dvr.m3u8'
        }
    ];
    function renderChannels(filteredChannels) {
        $('#channels').empty();
        filteredChannels.forEach((channel)=>{
            $('#channels').append(`
                <div class="col-6 col-md-4 col-lg-2 mb-4 d-flex justify-content-center">
                    <div class="card">
                        <img src="${channel.img}" class="card-img-top" width="250px" height="180px" alt="Imagem do ${channel.name}">
                        <div class="card-body text-center">
                            <h3 class="card-title mb-2">${channel.name}</h3>
                            <button class="btn py-1" onclick="playChannel('${channel.stream}')"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#ff192d" class="bi bi-play-btn-fill" viewBox="0 0 16 18">
  <path d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2m6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z"/>
</svg></button>
                        </div>
                    </div>
                </div>
            `);
        });
    }
    // Inicializar a exibição dos canais
    renderChannels(channels);
    // Inicializar o Video.js uma vez
    const player = videojs('video-player');
    $('#videoModal').on('hidden.bs.modal', function() {
        player.pause();
        player.currentTime(0); // Reseta o vídeo para o início
        $('#floating-remote').hide();
    });
    let currentChannelIndex = 0;
    window.playChannel = function(stream) {
        const index = channels.findIndex((channel)=>channel.stream === stream);
        if (index !== -1) currentChannelIndex = index;
        player.src({
            src: stream,
            type: 'application/x-mpegURL'
        });
        player.play();
        $('#videoModal').modal('show');
        $('#floating-remote').show();
    };
    function playNextChannel() {
        currentChannelIndex = (currentChannelIndex + 1) % channels.length;
        const nextChannel = channels[currentChannelIndex];
        playChannel(nextChannel.stream);
    }
    function playPrevChannel() {
        currentChannelIndex = (currentChannelIndex - 1 + channels.length) % channels.length;
        const prevChannel = channels[currentChannelIndex];
        playChannel(prevChannel.stream);
    }
    // Event listeners para os botões de controle remoto
    document.getElementById('next-channel').addEventListener('click', playNextChannel);
    document.getElementById('prev-channel').addEventListener('click', playPrevChannel);
    // Mostrar controle remoto ao mover o mouse dentro do modal
    let timeout;
    $('#videoModal').mousemove(function() {
        clearTimeout(timeout);
        $('#floating-remote').fadeIn();
        timeout = setTimeout(function() {
            $('#floating-remote').fadeOut();
        }, 15000);
    });
    // Lógica de busca
    $('#channel-search').on('input', function() {
        const query = $(this).val().toLowerCase();
        const filteredChannels = channels.filter((channel)=>channel.name.toLowerCase().includes(query));
        renderChannels(filteredChannels);
        if (filteredChannels.length === 0) $('#channels').append('<p class="text-center text-white">Canal n\xe3o encontrado.</p>');
    });
    document.getElementById('copyLinkKey').addEventListener('click', function() {
        var linkKeyInput = document.getElementById('linkKey');
        linkKeyInput.select();
        linkKeyInput.setSelectionRange(0, 99999); // Para dispositivos móveis
        navigator.clipboard.writeText(linkKeyInput.value);
        alert('Link copiado com sucesso!');
    });
});

//# sourceMappingURL=path0.557923a6.js.map
